import CurrentPlan from "@mapmycustomers/shared/types/plans/CurrentPlan";

import Iam from "@app/types/Iam";
import hasTrialExpired from "@app/util/hasTrialExpired";
import { parseApiDate } from "@app/util/parsers";

import { convertPlanToTier } from "./tier";

const buildCurrentPlan = (me: Iam): CurrentPlan => {
  const { plan } = me.organization;
  let nextPaymentDate = new Date(); // now, will be used for current paid plans
  if (plan.trialing) {
    nextPaymentDate = parseApiDate(me.organization.trialExpiresAt);
  } else if (plan.nextPaymentDate) {
    nextPaymentDate = parseApiDate(plan.nextPaymentDate);
  }
  return {
    isExpired: hasTrialExpired(me.organization) ?? false,
    isOldPlan: !(plan.metaData && plan.metaData.licenseLimit),
    // Provisioned by Sales/CSM and billed outside the app: no Stripe customer and no subscription.
    // That is the shape the server's guard refuses before it calls Stripe at all. An org with a
    // customer id but no subscription id still buys here, because the server adopts the
    // subscription already on that customer.
    isSalesManaged: !plan.trialing && !me.organization.stripeId && !me.organization.subscriptionId,
    licenses: me.organization.teamSize ?? (plan.trialing ? 0 : Math.max(1, plan.quantity)),
    nextPaymentDate,
    tier: convertPlanToTier(plan),
  };
};

export default buildCurrentPlan;
